import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '../../components/Button';
import { IconName } from '../../components/Icon';
import { ButtonVariant } from '../../config/colors';
import { LinkSignUp } from '../../components/LinkSignUp';
import { isNostrExtensionInstalled, getNostrPublicKey, signMessage } from '../../utils/NostrUtils';
import { authRepository } from '../../repositories/AuthRepository';
import { useAuth } from '../../hooks/useAuth';
import { useConfirm } from '../../hooks/useConfirm';
import { UserNotFoundOnLogin } from '../../repositories/Repository';

const ChooseAuthType: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [hasNostrExtension, setHasNostrExtension] = useState(false);
  const {setCredentialsOnLogin} = useAuth();
  const { openConfirm } = useConfirm();

  useEffect(() => {
    setHasNostrExtension(isNostrExtensionInstalled());
    
    setTimeout(() => {
      setHasNostrExtension(isNostrExtensionInstalled());
    }, 1000);
  }, []);

  const handleNip07Login = async () => {
    try {
      const publicKey = await getNostrPublicKey();
      if (!publicKey) {
        throw new Error('Failed to get public key from Nostr extension');
      }

      // Generate a random challenge message
      const challenge = `Orange Pill Login Challenge: ${Math.random().toString(36).substring(2, 15)}`;
      
      // Request signature from the extension
      const event = await signMessage(challenge);
      if (!event) {
        throw new Error('Failed to sign challenge message');
      }

      const { credentials, pleb } = await authRepository.loginWithNip07(event);
      await setCredentialsOnLogin(credentials, pleb);
      navigate('/home/chat');
    } catch (error: any) {
      console.error('Error during NIP-07 login:', error);
      if(error instanceof UserNotFoundOnLogin)
      {
        openConfirm({
          title: "Npub not found",
          message: "Your npub does not have an account",
          buttons: [
            { label: "Create account", href: process.env.REACT_APP_LINK_SIGNUP, target: "_blank", variant: ButtonVariant.inverted }, 
            { label: "Login with different npub", onClick: () => {}, variant: ButtonVariant.transparent }
          ],
        });
      }
      else
        openConfirm({
          message: (error.response?.data?.message ? error.response?.data?.message : 'Verification failed'),
          buttons: [
            { label: "OK", onClick: () => {}, variant: ButtonVariant.inverted },
          ],
        });
    }
  };

  return (
    <div className="flex flex-col items-center gap-6 flex-1">
      <h1 className="text-[36px] font-bold text-white">
        Login
      </h1>

      <Button
        variant={ButtonVariant.alwaysWhite}
        icon={IconName.EMAIL}
        onClick={() => navigate('/login/email', {
          state: {
            addAccount: location.state?.addAccount
          }
        })}
      >
        Login with Email
      </Button>

      {hasNostrExtension && (
        <Button
          variant={ButtonVariant.purple}
          icon={IconName.NOSTR_LOGO}
          iconSize={28}
          iconColor="#FFFFFF"
          onClick={handleNip07Login}
        >
          Login with Nostr Extension (NIP-07)
        </Button>
      )}

      <Button
        variant={ButtonVariant.purple}
        icon={IconName.NOSTR_LOGO}
        iconSize={28}
        iconColor="#FFFFFF"
        onClick={() => navigate('/login/nostr', {
          state: {
            addAccount: location.state?.addAccount
          }
        })}
      >
        Login with Nostr
      </Button>

      <LinkSignUp />
    </div>
  );
};

export default ChooseAuthType;
